import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

export default {
  ...zhLocale,
  language: {
    name: '中文',
    key: 'English'
  },
  scds: {
    platform_0: "CN",
    platform_1: "HK",
    platform_2: "TM",
    platform_5: "JD",
    platform_6: "ROOKIE",
    platform_7: "NBA",
    platform_8: "VHALL",
    platform_9: "DY",
    platform_11: "JD.COM FLG",
    platform_12: "JD.COM YA"
  },
  attribution: {
    fileUpload: '文件上传',
    attributeCalculate: '属性计算',
    attribution: '属性',
    InSeasonDownload: '下载In-Season产品',
    ProcessLog: '发布日志',
    Calculate: '计算',
    Publish: '发布',
    Chinese: '简中',
    English: 'EN',
    download: '下载',
    InSeason: '当季',
    AllProduct: '全部',
    Filter: '筛选',
    Select: '所选',
    search: '搜索',
    clear: '重置',
    ChooseFile: '选择文件',
    choose: '选择',
    Upload: '上传',
    fileType: '文件类型',
    fileType_1_1: "TM LOC",
    fileType_1_2: "Wash Label",
    fileType_1_3: "Global Attribute",
    fileType_1_4: "China GB Code",
    status: '处理进度',
    status_0: '待处理',
    status_1: '处理完成',
    status_2: '处理异常',
    status_3: '处理中',
    cancel: '取消',
    confirm: '确定',
    close: '关闭',
    pleaseUploadFile: "请上传文件！",
    uploading: "上传中",
    upload: "上传",
    pleaseChooseFile: "请选择文件！",
    addAttribution: "添加属性",
    selAttribution: "选择计算属性",
    detail: "详情",
    calculationRange: "计算范围",
    formulaMode: "计算方式",
    calculateAttribution: "计算属性",
    inSeason: "当季",
    selected: "所选",
    Intelligent: "智能",
    All: "全量",
    dataRange: '数据范围',
    dataSize: "数据粒度",
    file: "文件",
    info: "提示",
    pleaseChooseDetail: "请选择记录！",
    uploadSuccess: "上传成功！",
    uploadFailed: "上传失败！",
    downloadFailed: "下载失败！",
    running: "运行中",
    error: "异常",
    ok: "已完成",
    publish: "发布",
    publishError: "发布失败,稍候重试",
    publishOk: "发布成功！",
    pleaseChooseDataRange: "请选择数据范围！",
    pleaseChoosePlatform: "请选择发布平台！",
    pleaseChooseDataSize: "请选择数据粒度！",
    calculating: "系统开始计算！",
    pleaseChooseCalculationRange: "请选择计算范围！",
    pleaseChooseFormulaMode: "请选择计算方式！",
    pleaseChooseCalculateAttribution: "请选择计算属性！",
    hasCalculating: "属性计算中，请勿重复操作！",
    startTime: "开始时间",
    endTime: "结束时间",
    triggerBy: "触发人员",
    platform: "平台",
    elapsedTime: "耗时（S）",
    logStatus: "状态",
    inputValue: "输入值",
    cause: "原因",
    configuration: "配置",
    sku: 'SKU',
    calculateResult: '计算结果',
    latestRelease: '最新发布'
  },
  fitReport: {
    fileUpload: '文件上传',
    dataManage: '数据管理',
    fileType: '文件类型',
    ChooseFile: '选择文件',
    fileType_2_1: 'Fitting Report',
    fileType_2_2: 'YA Fitting Report',
    fileType_2_3: 'CS VOC',
    productName: '产品名称',
    diagnosisErrorCode1: '内容不是数值型',
    diagnosisErrorCode2: '内容不能为空',
    diagnosisErrorCode3: '包含禁用词/敏感词/负面词',
    diagnosisErrorCode4: '结尾不能为符号',
    diagnosisErrorCode5: '内容过长',
    diagnosisErrorCode6: '内容无效',
    diagnosisErrorCode7: '内容不能包含英文',
    upload: '上传',
    search: '搜索',
    download: '数据下载',
    downloadImage: '图片下载',
    selSeason: '请选择季度',
    excelName: "文件名称",
    createUser: "上传人",
    createTime: "上传时间",
    status: '处理状态',
    status_0: '待处理',
    status_1: '处理完成',
    status_2: '处理异常',
    status_3: '处理中',
    addSeason: '添加季度',
    editSeason: '编辑季度',
    season: '季度',
    pleaseChooseFile: "请选择文件！",
    uploading: "上传中...",
    saveInfo: "是否保存？",
    saveInfoIsNull: "内容不能为空，请输入！",
    productCategory: "产品分类",
    fitExperience: "试穿体验",
    customerFeedback: "客户反馈",
    commentCount: "评论数量",
    diagnosisStatus: "诊断状态",
    negativeJudgement: "负面评价",
    tryToFeel: "试穿感受",
    newSeason: "最新季度",
    publishStatus: "发布状态",
    operate: "操作",
    pleaseChooseDetail: "请选择记录！",
    downloadFailed: "下载失败！",
    detail: "详情",
    published: "已发布",
    unpublished: "未发布",
    normal: "正常",
    abnormal: "异常",
    warning: "预警",
    noFeedback: "无反馈"
  },
  common: {
    resetPwd: '重置密码',
    languageSwitch: '语言切换',
    logout: '退出',
    no: '序号',
    operate: '操作',
    list: '列表',
    search: '搜索',
    reset: '重置',
    everyPageShow: '每页展示',
    to: '至',
    edit: '编辑',
    delete: '删除',
    recovery: '恢复',
    add: '添加',
    sure: '确定',
    cancel: '取消',
    close: '关闭',
    startDate: '开始日期',
    endDate: '结束日期',
    confirm: '确认',
    detail: "详细",
    up: '上移',
    down: '下移',
    top: '置顶',
    bottom: '置底',
    ok: '确定',
    pleaseSelect: '请选择',
    pleaseInput: '请输入',
    refresh: '刷新',
    prevPage: '上一页',
    nextPage: '下一页',
    quit: '退出',
    repeatSubmit: '请勿重复提交',
    modifiedPassword: '修改密码',
    sysInfo: '系统提示',
    selectAll: '全选',
    treate: '处理',
    addSuccess: '添加成功！！',
    addFailed: '添加失败！！',
    editorSuccess: '编辑成功！！',
    editorFailed: '编辑失败！！',
    deleteSuccess: '删除成功！！',
    deleteFailed: '删除失败',
    upSuccess: '上移成功！！',
    downSuccess: '下移成功！！',
    upFailed: '空白段落，不可上移',
    recallSuccess: '重置成功！！',
    recallFailed: '重置失败',
    deleteInfo: '此操作将永久删除该文件, 是否继续?',
    deleteTranslate: '此操作将永久删除该段落, 是否继续?',
    pleaseOnlyOneCondition: '至少选择一个条件！！',
    paramFormatError: '必填项未填写，请修改后重新提交',
    numberFormatIsError: '请输入正确的数字格式',
    emailFormatError: '请输入正确的邮箱格式',
    notUnique: '已经存在，请重新输入',
    save: '保存',
    preview: '预览',
    submitAll: '全部提交',
    back: '返回',
    view: '查看',
    right: '正确',
    fault: '错误',
    cancelSuccess: '取消成功',
    sureSuccess: '提交成功',
    hasNo: '无',
    hasYes: '有',
    of: '的',
    idSubmit: "是否全部提交？",
    isHkOnly: "是否已经审阅HK only的图片",
    info: '提示',
    upper: '上一级',
    import: '导入',
    createTime: '创建时间',
    createBy: '创建人',
    updateTime: '更新时间',
    updateBy: '更新人',
    platform: '平台',
    export: '导出',
    publish: '发布',
    publishAll: "发布全部",
    type: '类型',
    downloadList:"批量下载",
    process:"处理中",
    successProcess:"处理成功",
    toProcess:"待处理",
    processFailed:"处理失败",
    pleaseUploadFile: "请上传文件！",
    pleaseChooseFile: "请选择文件！",
    test: "测试",
    download: "下载",
    operationSuccess: "操作成功",
    noData: '暂无数据',
    operationFailed: "操作失败",
    successExport: "导出成功",
    exportFailed: "导出失败",
    selectDate: "选择日期",
    upload: '上传',
    status: '状态',
    fileUpload: '文件上传',
    ChooseFile: '选择文件',
    uploadSuccess: "上传成功！",
    publishOk: "发布成功",
    batchImport: "批量导入",
    insert: "新增",
    deleteDataInfo: "是否确认删除所选内容",
    replace: '替换',
    Yes: '是',
    No: '否',
    downloadFailed: "下载失败！",
    downloadSuccess: "下载成功！",
    keyword: '关键字',
    phraseProjectName: 'Phrase Project Name',
    enTriggerTime: 'EN Trigger Time',
    completionTimeOfTranslation: '翻译完成时间',
    reviewTime: '审核时间',
    uploadFailed: "上传失败！",
},
  menu: {
    scds: "SCDS",
    scdsTaskList: "资产交付管理",
    assetConfidentialityManagement: "资产保密管理",
    attribution: '属性管理',
    image: '图片校对',
    sizeChart: '尺码表',
    copyTrackingList: 'TL列表',
    uploadTranslate: 'HK翻译上传',
    copySample: '拍样上传/管理',
    uploadAirbag: '切样回传',
    copyDistribute: 'CN订单管理',
    copyDistributeHk: 'HK订单管理',
    copyTranslate: 'CN翻译校对',
    copyTranslateHkList: 'HK翻译校对',
    copyQc: 'CN文案QC',
    copyQcHkList: 'HK文案QC',
    copyTaskList: 'CN任务管理',
    copyTaskListHk: 'HK任务管理',
    sysUser: '用户管理',
    sysRole: '角色管理',
    sysApiRole: '产品API角色管理',
    copy: '素材校对',
    dictForbidden: '禁用词',
    dictProfessional: '专业词',
    system: '系统管理',
    imageTrackingList: 'TL列表',
    imageErrorLogList: 'Error Log Sync',
    UpdateImageTL: 'Update Image TL',
    UpdateCopyTL: 'Update Copy TL',
    SysReport: 'SysReport',
    imageDistribute: '订单管理',
    imageCompare: '图片校对',
    imageQc: '图片QC',
    imageTaskList: '任务管理',
    copyAirbag: '产品功能',
    dictCopyErrorType: '文案错误类型',
    dictImageErrorType: '图片错误类型',
    uploadEnCopy: 'HK英文上传',
    sampleDistribute: '触发调样',
    copyDistributeSample: '触发调样',
    masterData: '主数据',
    sampleUpload: '拍样上传',
    copyReturn: 'CN文案回传',
    startTranslate: '开始处理',
    copyCombine: 'TM版本合并',
    copyCombineList: 'TM版本合并',
    productManage: "图片/视频管理",
    copyManage: "PDP文案管理",
    readiness: 'Image Readiness',
    copyReadiness: 'Copy Readiness',
    leadTime: "LeadTime",
    report: '报表',
    copyProduct: 'Copy版本',
    sysMail: '邮件管理',
    SftpUpload: 'Infographic 上传',
    DownloadZip: "下载",
    AssetDownload: "资产交付",
    CopyDownload: "PDP文案",
    ImageDownload: "PDP图片",
    localImage: "本地图片",
    dataImport: "数据上传",
    assetReview: "素材审核",
    localImageDistribute: "订单管理",
    localImageCompare: '素材校对',
    localImageQc: '素材QC',
    localImageTaskList: '任务管理',
    attributeManagement: '属性配置',
    fitReport: '试穿报告',
    trackingList: 'TL列表',
    sysOrg: "组织管理",
    assetsUploadList: "素材上传",
    sysGlossary: "翻译词汇表",
    sysDisclaimer: "免责声明",
    sysDict: "字典管理",
    biRepository: "校对知识库",
    proofRule: "校对规则",
    sysApiInfo: "运维助手",
    sysBiRepository: "校对规则",
    productKnowledge: "产品知识",
    imageCertificateList: "合格证管理",
    licenseUpload: "许可证",
    sellPoint: "卖点信息",
    keyWords: "属性&关键字上传",
    copyDatabase: "资料文件上传",
    laydownMeasurement: "平铺测量",
    labelManagement: "标签管理",
    sizeAndFit: "Size & Fit",
    storeManage: "店铺上架管理",
    errorTicket: "Error Ticket",
    HWTable: "H/W Table",
    fastAsset: "Fast Asset",
    fastDataImport: "数据导入",
    fastAssetReview: "资产审核",
    fastDistribute: "订单管理",
    fastImageCompare: "图片校对",
    fastImageQc: "图片QC",
    fastTaskList: "任务管理",
    AGC: "AGC Asset",
    AgcDataImport: "数据导入",
    AgcAssetReview: "资产审核",
    AgcOrderManage: "订单管理",
    AgcImageCompare: "图片校对",
    AgcImageQc: "图片QC",
    AgcTaskList: "任务管理",
    colorDescription: "颜色翻译",
    ruleManagement: "关键字规则管理",
    pictureVideo: "图片/视频",
    copyManagement: "文案",
    sizeAttritbute: "尺码/属性",
    sampleUploadList: "拍样调样",
    launchCalendarCopy: "Launch Calendar Copy",
    pdpImageVideo: "GlobalPDP图片/视频",
    LpdpimageVideo: "LocalPDP图片/视频",
    pdpCopy: "PDP文案",
    knowledgeBase: "校对知识库",
    assetDownload: "资产下载",
    publishManage: "上架/交付管理",
    epdpCopy: 'EPD文案',
    epdpListUpload: '清单上传',
    epdpCopyReview: '任务审核',
    epdpCopyQuery: 'EPD文案管理',
  },
  ruleManagement: {
    divisionInfo: 'DIVISION 不能为空',
    categoryInfo: 'CATEGORY 不能为空',
    ageInfo: 'AGE 不能为空',
    lineInfo: 'LINE 不能为空',
    keywordInfo: 'KEYWORD 不能为空',
    shortCircuitInfo: 'SHORT CIRCUIT 不能为空',
    imageSelect: '请选择图片',
    clickHere: '点击此处',
    pasteImage: '按 Ctrl+V，粘贴图片',
    fileName: '文件名称',
    uploadUser: '上传人',
    uploadTime: '上传时间',
    status: "处理状态",
    status_0: "待处理",
    status_1: "处理完成",
    status_2: "处理异常",
    status_3: "处理中",
    actionLineBegin: '段首',
    actionLineEnd: '段尾',
    actionLineEmpty: '空',
    actionLine1Info: 'ACTION LINE 1 不能为空',
    positionLine1Info: 'POSITION LINE 1 不能为空',
    contentLine1Info: 'CONTENT LINE 1 不能为空',
    replaceLine1Info: 'REPLACE LINE 1 不能为空',
    actionLine2Info: 'ACTION LINE 2 不能为空',
    positionLine2Info: 'POSITION LINE 2 不能为空',
    contentLine2Info: 'CONTENT LINE 2 不能为空',
    replaceLine2Info: 'REPLACE LINE 2 不能为空'
  },
  sysUser: {
    organization: '组织',
    realName: '用户名',
    password: '密码',
    gmtModified: '修改时间',
    orgName: '组织',
    phone: '手机',
    isDelete: '是否删除',
    id: '',
    userName: '账号',
    gmtCreate: '创建时间',
    email: '邮箱',
    role: '角色',
    reset: '重置密码',
    resetSuccess: '重置密码成功',
    unlock: "解锁",
    unlockSuccess: "解锁成功",
    deleteInfo: '此操作将永久删除用户, 是否继续?',
    copyTaskInWork: "无法删除，该用户存在与文案相关的待执行任务",
    imageTaskInWork: "无法删除，该用户存在与图片相关的待执行任务",
    lang: "语言",
    lang_en: "en",
    lang_zh: "zh"
  },
  sysApiInfo:{
    name:"接口名称",
    url:"接口地址",
    description:"接口描述",
    use:"调用",
    update:"更新",
    delete:"删除",
    useInfo:"是否调用该接口",
    monitor:"监控",
    configuration:"名称",
    sentence:"SQL语句",
  },
  sysRole: {
    gmtModified: '修改时间',
    roleCode: '角色代码',
    roleName: '角色名称',
    roleType: '角色类型',
    roleType_null: '',
    roleType_0: '界面权限',
    roleType_1: '按钮权限',
    roleType_2: '特殊权限',
    roleType_3: '自定义角色',
    parentId: '父节点',
    sort: '排序',
    description: '角色说明',
    id: '',
    gmtCreate: '创建时间',
    permission: '权限分配',
    assginAuthSucess: '权限分配成功',
    deleteInfo: '此操作将永久删除角色, 是否继续?'
  },
  login: {
    forgetPassword: '请联系管理员',
    accountNotExist: '该账号不存在',
    passowrdIsWrong: '密码错误',
    userLocked: "密码已过期.请修改密码",
    passwordExpiration1: "密码已过期.请修改密码",
    passwordExpiration: "密码还有DayNumber天过期.请修改密码",
    noAuth: '当前账户没有权限，请联系管理员分配',
    userAuthIsOut: '用户登陆信息过期，请重新登陆',
    changePassword: '修改密码',
    oldPassword: '旧密码',
    newPassword: '新密码',
    repeatPassword: '重新输入',
    passwordNotNull: '密码不能为空',
    passwordNotEquals: '两次密码不一致',
    passwordVerifyComplexity: '至少8位 (包含字母/数字/符号)',
    changePasswordSuccess: '修改密码成功，需要重新登陆',
    emailNotExist: '账号未绑定邮箱',
    sendEmailError: '发送验证码失败，请重新尝试',
    validCodeNotExist: '验证码不存在，请重新尝试',
    validCodeNotValid: '验证码失效，请重新申请验证码',
    validCodeNotEqual: '验证码验证失败，请重新输入',
    userNameNotNull: '用户名不能为空',
    validCodeNotNull: '验证码不能为空',
    sendCodeSuccess: '验证码发送成功，请登录您的邮箱查看',
    notUser: "您暂没有AMT登陆权限，请联系管理员"
  },
  trackingList: {
    startDate: "开始日期",
    endDate: "结束日期",
    listType: "文件类型",
    all: "全部",
    listType_0: "DAM Tracking List",
    listType_1: "LOC Tracking List",
    listType_2: "DAM Campaign List",
    listType_3: "LOC Campaign List",
    listType_4: "ON-Shelf List",
    listType_6: "VHALL ON-Shelf List",
    listType_5: "DML",
    listType_10: "DY DML",
    listType_11: "HW DML",
    listType_12: "QAP List",
    search: "查询",
    reset: "重置",
    chooseFile: "选择文件",
    loading: "加载中...",
    upload: "上传",
    uploadTrackingList: "上传TrackingList",
    uploadCampaignList: "上传CampaignList",
    uploading: "上传中...",
    excelName: "文件名称",
    createUser: "上传人",
    createTeam: "上传团队",
    createTime: "上传时间",
    pleaseChooseFile: "请选择文件！",
    pleaseUploadFile: "请上传文件！",
    uploadSuccess: "上传成功！",
    imageTaskInProcess: '图片任务后台生成中，请稍后再试',
    uploadFailed: "上传失败！",
    updateTask: "确认当天TL已全部上传",
    uploadAll: "您今天已经全部上传完TrackingList和CampaignList，确定开始更新任务吗？",
    submitSuccess: "您已提交成功，任务开始更新！",
    excelIsParsing: "文件解析未处理完成，请稍后重新提交！",
    taskIsRunning: "目前任务正在更新，请稍后重新提交！",
    uploadSkuList: "上传skuList",
    status: "当前状态",
    status_0: "待处理",
    status_1: "处理完成",
    status_2: "处理异常",
    status_3: "处理中",
    fileUpload: "文件上传",
    createTask: "任务生成",
    chooseFileType: "请选择文件类型！"
  },
  imageErrorLogList: {
    startDate: "开始日期",
    endDate: "结束日期",
    createTime: "上传时间",
    createUser: "上传人",
    excelName: "文件名称",
    chooseFile: "选择文件",
    loading: "加载中...",
    upload: "上传",
    uploading: "上传中...",
    uploadImageErrorLogList: "上传Image Error Log",
    pleaseChooseFile: "请选择文件！",
    uploadSuccess: "上传成功！"
  },
  sampleUpload: {
    id: "订单编号",
    productCode: "SKU",
    productName: "产品名称",
    category: "产品分类",
    isHkOnly: "是否HK Only",
    hkOnly_0: "否",
    hkOnly_1: "是",
    inventoryStatus: '库存状态',
    existInventory_0: "无",
    existInventory_1: "有",
    sampleStatus: '调样状态',
    sampleStatus_0: "未调样",
    sampleStatus_1: "已调样",
    sampleStatus_2: "已上传",
    sampleStatus_3: "已发货",
    sampleStatus_4: "调样失败",
    prodType: "产品类型",
    genderGroup: "性别组",
    productInfoOwner: "下单人",
    status: "订单状态",
    cnLaunchDate: "OMD",
    startDate: "开始日期",
    endDate: "结束日期",
    search: "查询",
    reset: "重置",
    refresh: "刷新",
    distribute: "分发",
    recall: "撤回",
    operation: "操作",
    chooseImage: "选择图片",
    loading: "加载中...",
    upload: "上传",
    preview: "预览",
    finish: "完成",
    uploading: "上传中...",
    all: "全部",
    high: "高",
    medium: "中",
    low: "低",
    compareUser: "校对人",
    chooseUser: '选择用户',
    sampleDistributeUser: '调样人',
    sampleDistributeTeam: '调样团队',
    sample: "发送调样",
  },
  imageEditor: {
    loadImageError: '图片载入异常，无法操作',
    flagPositionError: '标记位置大小有异常，请重新标注',
    pleaseSelectFlag: '请切换到删除模式下并选择需要删除的标记'
  },
  imageSelected: {
    noImage: '暂无图片',
    selectOnlyOne: '至少选择一张图片进行操作'
  },
  imageOperation: {
    sku: 'SKU',
    st: 'ST',
    prem: 'PREM',
    rawImage: '原图',
    refresh: '刷新',
    clear: '清除',
    selectSample: '选择拍样',
    selectCertificate: '选择合格证',
    selectShoeBox: '选择鞋盒贴标',
    global: 'Global',
    sample: '拍样',
    change: '切换',
    imageSelect: '选择图片',
    compareResult: '校对结果',
    resultType: '错误类型',
    resultDescription: '错误描述',
    imageName: '图片名称',
    direction: '方向',
    compareTime: '校对时间',
    compareUser: '校对人',
    qcResult: 'QC结果',
    qcTime: 'QC时间',
    qcUser: 'QC人',
    qcRemark: 'QC建议',
    resultList: '错误列表',
    finalCopy: '最终正确版本',
    compare: '校对',
    backList: '返回任务列表',
    errNumber: '编号',
    all: "全部",
    high: "高",
    medium: "中",
    low: "低",
    qc: 'QC',
    startTreate: '开始处理',
    approveDescription: 'QC描述',
    approveResult: 'QC结果',
    approveHistory: 'QC历史版本',
    reject: '全部驳回',
    approve: '全部通过',
    globalImageType: '图片类型',
    globalImageType_0: 'ST',
    globalImageType_1: 'PREM',
    noChangeHasFlag: '已经存在标记，不能切换拍样图片',
    notSubmit: '还有图片没处理完，无法提交',
    notChooseCertificate: '还没有选择合格证，无法提交',
    submitSuccess: '提交成功',
    openImageError: '图片载入失败或未选择拍样，无法打开原图',
    qcStatus_1: '不通过',
    qcStatus_0: '未QC',
    qcStatus_null: '未QC',
    qcStatus_undefined: '未QC',
    qcStatus_empty: '',
    qcStatus_2: '通过',
    qcStatusHistory_1: '不通过',
    qcStatusHistory_0: '通过',
    qcStatusHistory_null: '通过',
    qcStatusHistory_undefined: '通过',
    qcStatusHistory_empty: '',
    qcStatusHistory_2: '通过',
    compareStatus_0: '未校对',
    compareStatus_1: '错误',
    compareStatus_2: '正确',
    historyVersion: '历史版本',
    noSample: '未选择拍样图片，无法操作',
    compareStatusRight: '校对结果为正确，无法操作',
    notChangeCompareResult: '存在异常标记，不能修改校对结果为正确',
    errorMessageNotNull: '错误描述不能为空',
    errorTypeNotNull: '错误类型不能为空',
    onlyOneErrorFlag: '至少需要一个错误标记',
    flagNumberNotEqual: '两边标记数量或编号不一致，请检查',
    qcErrorMsgNotNull: 'QC描述不能为空',
    notQcSubmit: '至少需要一个错误才能驳回',
    mustAllApprove: '必须全部通过，才能通过QC',
    historyApprove: '历史QC',
    compareStatus_undefined: '未校对',
    compareDescriptionIsError: "校对状态异常，错误描述不能为空，详细信息：",
    errorTypesIsError: "校对状态异常，错误类型不能为空，详细信息：",
    sampleImageIsNull: "校对状态异常，拍样图片不能为空，详细信息：",
    imageNormalCompareIsNull: "校对状态异常，校对状态不能为空，详细信息：",
    imageNormalCompareStatusIsError: "校对状态异常，校对状态与实际结果不一致，详细信息：",
    compareErrorIsNotEmpty: "校对状态异常，校对错误，至少应包含一条错误信息，详细信息：",
    errorFlagIsExistEqual: "校对状态异常，错误标记序号不能存在相等，详细信息：",
    flagIsMustBeExist: "校对状态异常，错误标记原图和拍样图必须一一对应，详细信息：",
    flagPositionIsError: "校对状态异常，错误标记位置或大小有异常，详细信息：",
    taskHasCompletedNotOperate: "校对状态异常，任务已经完成无法修改，详细信息：",
    taskHasSubmitNotOperate: "校对状态异常，任务已经提交到QC无法修改，详细信息：",
    imageShow: "查看图片",
    closeUps: "特写图",
    image: "图片"
  },
  imagePagination: {
    completed: '已完成'
  },
  assetDownload: {
    season: "季度",
    gender: "性别",
    status: "状态",
    download: "下载",
    platform: "平台",
    format: "格式",
    drawerTitle: "下载栏",
    maxChooseImage: "一次最多下载10个",
    maxChooseCopy: "一次最多下载50个",
    noChecked: "未选中",
    pleaseSelect: "请选择",
    noAccessed: "无文案下载",
    PackagingFailed: '打包失败',
    division: '分类',
    dimension: '尺寸',
    resolution: '分辨率',
    fsize: '文件大小/SKU'
  },
  imageDistribute: {
    id: "订单编号",
    productCode: "SKU",
    productName: "产品名称",
    category: "产品分类",
    imageStatus: '图片状态',
    existGlobalImage_0: "无",
    existGlobalImage_1: "有",
    inventoryStatus: '库存状态',
    existInventory_0: "无",
    existInventory_1: "有",
    sampleStatus: '调样状态',
    sampleStatus_0: "未调样",
    sampleStatus_1: "已调样",
    sampleStatus_2: "已上传",
    sampleStatus_3: "已发货",
    sampleStatus_4: "调样失败",
    prodType: "产品类型",
    genderGroup: "性别组",
    snkrsLaunch: "SNKRS",
    snkrsLaunch_Y: "是",
    snkrsLaunch_N: "否",
    snkrsLaunch_: "否",
    taskStatus: "任务状态",
    distributeStatus: "分发状态",
    taskStatus_0: "未分发",
    taskStatus_1: "未接收",
    taskStatus_2: "校对中",
    taskStatus_3: "QC中",
    taskStatus_4: "已完成",
    cnLaunchDate: "OMD",
    startDate: "开始日期",
    endDate: "结束日期",
    priorityLevel: "优先级",
    priorityLevel_0: "初始中",
    priorityLevel_1: "低",
    priorityLevel_2: "中",
    priorityLevel_3: "高",
    priorityLevel_4: "紧急",
    search: "查询",
    reset: "重置",
    refresh: "刷新",
    distribute: "分发",
    recall: "撤回",
    operation: "操作",
    all: "全部",
    compareUser: "校对人",
    taskTimes: "校对次数",
    chooseUser: '选择用户',
    isCampaign: '活动状态',
    isCampaign_null: '否',
    isCampaign_0: '否',
    isCampaign_1: '是',
    taskType: '任务类型',
    taskType_null: '',
    taskType_1: 'New',
    taskType_2: 'Overdue',
    certificate: '合格证',
    dueDate: '到期日',
  },
  imageTaskList: {
    id: "订单编号",
    productCode: "SKU",
    productName: "产品名称",
    category: "产品分类",
    imageStatus: '图片状态',
    existGlobalImage_0: "无",
    existGlobalImage_1: "有",
    inventoryStatus: '库存状态',
    existInventory_null: "无",
    existInventory_0: "无",
    existInventory_1: "有",
    sampleStatus: '调样状态',
    sampleStatus_null: "未调样",
    sampleStatus_0: "未调样",
    sampleStatus_1: "已调样",
    sampleStatus_2: "已上传",
    sampleStatus_3: "已发货",
    sampleStatus_4: "调样失败",
    prodType: "产品类型",
    genderGroup: "性别组",
    snkrsLaunch: "SNKRS",
    snkrsLaunch_Y: "是",
    snkrsLaunch_N: "否",
    distributeStatus: "任务状态",
    taskStatus: "任务状态",
    taskStatus_0: "未分发",
    taskStatus_1: "未接收",
    taskStatus_2: "校对中",
    taskStatus_3: "QC中",
    taskStatus_4: "已完成",
    qcUser:'QC人',
    qcResult: 'QC结果',
    qcResult_0: '未QC',
    qcResult_1: '不通过',
    qcResult_2: '通过',
    qcStatus: "QC结果",
    qcStatus_0: "未QC",
    qcStatus_1: "不通过",
    qcStatus_2: "通过",
    isDelete: "订单状态",
    isDelete_0: "有效",
    isDelete_1: "关闭",
    damStatus: "抽检状态",
    damStatus_0: "未抽检",
    damStatus_1: "已打回",
    isCampaign: "活动状态",
    isCampaign_0: "否",
    isCampaign_1: "是",
    cnLaunchDate: "OMD",
    startDate: "开始日期",
    endDate: "结束日期",
    priorityLevel: "优先级",
    priorityLevel_0: "初始中",
    priorityLevel_1: "低",
    priorityLevel_2: "中",
    priorityLevel_3: "高",
    priorityLevel_4: "紧急",
    search: "查询",
    reset: "重置",
    refresh: "刷新",
    distribute: "分发",
    recall: "撤回",
    operation: "操作",
    all: "全部",
    compareUser: "校对人",
    taskTimes: "校对次数",
    reOpen: "重新校对",
    imageTaskDetail: "任务详情",
    reOpenDescription: "重新校对原因",
    recheck: '抽检',
    memberShip: 'MEMBERSHIP OFFER DATE',
    isPremStatus: 'PREM',
    isPremError_0: '正确',
    isPremError_1: '错误',
    isStStatus: 'ST',
    isStError_0: '正确',
    isStError_1: '错误',
    qcTime: 'QC时间',
    taskType: '任务类型',
    taskType_null: '',
    taskType_1: 'New',
    taskType_2: 'Overdue',
    certificate: '合格证',
    organization: '组织名称',
    urgent: '加急',
    cancelUrgent: '取消加急',
    urgentDate: '加急日',
    dueDate: '到期日',
    isUrgent: '是否加急',
    isUrgent_0: '否',
    isUrgent_1: '是',
    isUrgent_null: '否',
    sampleDistributeTime: "调样/发货日期",
    isHideImage: '隐藏状态',
    pendingType: "pending原因",
    pendingType_0: "无",
    pendingType_1: "等待气垫切割",
    pendingType_2: "等待防水报告",
    pendingType_3: "等待拍样更新",
    pendingType_4: "等待再生材料报告",
    pendingType_5: "等待防晒报告",
  },
  copyTaskList: {
    id: "订单编号",
    productCode: "SKU",
    style: "STYLE",
    productName: "产品名称",
    category: "产品分类",
    enCopyStatus: '英文状态',
    zhCopyStatus: '中文状态',
    imageStatus: '图片状态',
    existGlobalImage_0: "无",
    existGlobalImage_1: "有",
    productInfoOwner: "下单人",
    compareUser: "校对人",
    status: "订单状态",
    omd: "OMD",
    cnLaunchDate: "发布时间",
    hkLaunchDate: "HK发布时间",
    prodType: "产品类型",
    chooseImage: "选择图片",
    loading: "加载中...",
    upload: "上传",
    uploading: "上传中...",
    isFirst: '是否首次',
    inventoryStatus: '库存状态',
    existInventory_0: "无",
    existInventory_1: "有",
    sampleStatus: '调样状态',
    sampleStatus_0: "未调样",
    sampleStatus_1: "已调样",
    sampleStatus_2: "已上传",
    sampleStatus_3: "已发货",
    sampleStatus_4: "调样失败",
    platformType: "平台类型",
    platformType_0: "CN",
    platformType_1: "HK",
    platformType_2: 'TMALL',
    platformType_3: 'CN & TMALL',
    needAirbag: "需要切样",
    needAirbag_0: "否",
    needAirbag_1: "是",
    airbagStatus: "切样状态",
    airbagStatus_0: "未切样",
    airbagStatus_1: "已切样",
    writingStatus: "COPY WRITING",
    writingStatus_0: "否",
    writingStatus_1: "是",
    existTranslate: "翻译状态",
    existTranslate_0: "无",
    existTranslate_1: "有",
    genderGroup: "性别组",
    snkrsLaunch: "SNKRS",
    snkrsLaunch_Y: "是",
    snkrsLaunch_N: "否",
    startDate: "开始日期",
    endDate: "结束日期",
    priorityLevel: "优先级",
    priorityLevel_0: "初始中",
    priorityLevel_1: "低",
    priorityLevel_2: "中",
    priorityLevel_3: "高",
    priorityLevel_4: "紧急",
    taskStatus: "任务状态",
    taskStatus_0: "未分发",
    taskStatus_1: "未接收",
    taskStatus_2: "校对中",
    taskStatus_3: "QC中",
    taskStatus_4: "已完成",
    qcResult: 'QC结果',
    qcResult_0: '未QC',
    qcResult_1: '不通过',
    qcResult_2: '通过',
    damStatus: "抽检状态",
    damStatus_0: "未抽检",
    damStatus_1: "已打回",
    isCampaign: "活动",
    isCampaign_0: "否",
    isCampaign_1: "是",
    search: "查询",
    reset: "重置",
    refresh: "刷新",
    distribute: "分发",
    recall: "撤回",
    operation: "操作",
    all: "全部",
    translateUser: "校对人",
    translateTime: "校对时间",
    qcUser: "QC人",
    qcTime: "QC时间",
    reOpenDescription: "重新校对原因",
    startDate2: "翻译时间",
    lingotekOrOffline: "翻译来源",
    lingotekOrOffline_0: "Lingotek",
    lingotekOrOffline_1: "Offline",
    lingotekOrOffline_2: "无",
    lingotekOrOffline_3: "Phrase",
    recallMessage: "当前任务已经撤回无法进行校对",
    cancelMessage: "当前任务已经取消无法进行校对",
    taskType2: "翻译来源",
    taskType2_0: "Translation",
    taskType2_1: "Copywriting",
    lastUpdated: "翻译日期",
    pendingType: "pending原因",
    pendingType_0: "无",
    pendingType_1: "等待气垫切割",
    pendingType_2: "等待防水报告",
    pendingType_3: "等待拍样更新",
    pendingType_4: "等待再生材料报告",
    pendingType_5: "等待防晒报告",
    existInventory: "",
    taskType: "任务类型",
    taskType_0: "NEW",
    taskType_1: "UPDATE",
    taskType_2: "过期失效",
    specialCase: "KEY",
    campaign: "活动",
    reject: "驳回",
    reOpen: "重做",
    sizingFit: "翻译类型",
    sizingFit_0: "PDP",
    sizingFit_1: "S&F",
    publishError: "发布失败,稍候重试",
    publishOk: "发布成功",
    reOpenTask: "重新校对",
    copyTaskDetail: "任务详情",
    organization: '组织名称',
    urgent: '加急',
    cancelUrgent: '取消加急',
    urgentDate: '加急日',
    dueDate: '到期日',
    isUrgent: '是否加急',
    isUrgent_0: '否',
    isUrgent_1: '是',
    isUrgent_null: '否'
  },
  dictForbidden: {
    gmtModified: "修改时间",
    forbiddenWord: "禁用词",
    remark: "备注",
    id: "",
    gmtCreate: "创建时间",
    platformType: '平台类型',
    platformType_0: 'CN',
    platformType_1: 'HK'
  },
  dictProfessional: {
    gmtModified: "修改时间",
    isDelete: "",
    professionalWord: "专业词",
    remark: "说明",
    id: "",
    professionalTranslate: "翻译",
    gmtCreate: "创建时间",
    platformType: '平台类型',
    platformType_0: 'CN',
    platformType_1: 'HK'
  },
  copyAirbag: {
    sampleCuttingManagement: "切样管理",
    season: "季度",
    category: "产品分类",
    style: "STYLE",
    styleName: "类型名称",
    sku: "SKU",
    existAirbag: "气垫状态",
    existAirbag_Y: "有",
    existAirbag_N: "无",
    airbagQty: "气垫数量",
    insole: "鞋垫",
    forefoot: "前掌",
    hell: "后跟",
    fullLength: "全掌",
    airbagType: "气垫类型",
    fullLengthCarbon: "中底碳板",
    plasticBoard: '中底塑料板',
    airbagStatus: "切样状态",
    airbagStatus_0: "未切样",
    airbagStatus_1: "已切样",
    airbagDate: "切样时间",
    chooseAirbagAllFile: "选择切样总表",
    chooseAirbagInfoFile: "选择切样信息",
    AirbagAllFile:"切样总表",
    AirbagInfoFile:"切样信息",
    productCode: "SKU",
    productName: "产品名称",
    download: "批量下载",
    prodType: "产品类型",
    status: "订单状态",
    cnLaunchDate: "发布时间",
    hkLaunchDate: "HK发布时间",
    startDate: "开始日期",
    endDate: "结束日期",
    search: "查询",
    reset: "重置",
    refresh: "刷新",
    operation: "操作",
    chooseImage: "选择图片",
    loading: "加载中...",
    upload: "上传",
    uploading: "上传中...",
    all: "全部",
    fileType:"文件类型",
    chooseFile:"选择文件",
    uploadSuccess: "上传成功！",
    uploadFailed: "上传失败！",
  },
  StyleAvailableRecycled: {
    season: '季度',
    style: 'STYLE',
    division: '品类',
    productName: '品名',
    productTable: '是否含有再生材料',
    recycled: '材料含量',
    comments: '备注',
    functions:'功能',
    protectionLevel:'防护等级',
    testingResult:'测试结果',
    sourceReport:'报告来源',
    confirmDate:'报告日期',
  },
  contrastTranslation: {
    copyType: '文案类型',
    rangeOfApplication: '适用范围',
    qcRemark: 'QC建议',
    professionalWordCheck: "专业词检查",
    forbiddenWordCheck: "禁用词检查",
    backList: "返回列表",
    yes: "检测到有气垫",
    source: "英文",
    linguistiscReview: "Linguistic Review",
    sepcReview: "Spec Review",
    segmentOrder: "序号",
    translation: "翻译",
    comment: "备注",
    translateProblems: "翻译问题",
    takeSample: "拍样",
    professionalWordResult: "专业词结果",
    forbiddenWordResult: "禁用词结果",
    allSubmitted: "全部提交",
    specialCase: "G转K",
    rejected: "驳回",
    no: "序号",
    version: "版本号",
    translateTime: "修改时间",
    translateUser: "修改人",
    qcTime: "QC时间",
    qcUser: "QC人",
    qcStatus: "QC結果",
    updateTime: "修改时间",
    modifier: "修改人",
    qualityTime: "QC时间",
    qualityPeople: "QC人",
    operate: "操作",
    view: "查看",
    qualityResults: "QC结果",
    through: "通过",
    notThrough: "不通过",
    chooseImg: "选择图片",
    viewImg: "查看图片",
    airbagDate: "切样时间",
    category: "品类",
    styleName: "品名",
    airbagStatus: "切样状态",
    airbagStatus_0: "未切样",
    airbagStatus_1: "已切样",
    existAirbag: "气垫状态",
    existAirbag_Y: "有",
    existAirbag_N: "无",
    airbagQty: "气垫数量",
    insole: "鞋垫",
    forefoot: "前掌",
    hell: "后跟",
    fullLength: "全掌",
    airbagType: "气垫类型",
    addDisclaimer: "添加免责",
    addSegment: "添加段落",
    addBlankSegment: "添加空白段落",
    gmtCreate: "创建时间",
    cnCopyDelivered: "校对日期",
    finalReview: "Final Review",
    gmtModified: "校对完成时间",
    taskByStyle: "Task",
    taskByStyle_0: "BY STYLE",
    taskByStyle_1: "BY SKU",
    sizingFit: "SIZE&FIT",
    sizingFit_0: "不是",
    sizingFit_1: "是",
    qcStatus_1: "不通过",
    qcStatus_2: "通过",
    comments: "备注",
    rejectComment: "请选择QC结果不通过并填写原因",
    hkRejectComment: "请填写驳回原因",
    submitComment: "当前存在未通过的翻译校对",
    rejectCommentFailed: "驳回失败，请重新尝试",
    segmentInfo: "请选择段落或添加空白段落",
    finalVersion: "最终正确版本",
    historyVersion: "历史版本",
    viewQcDescription: "驳回历史",
    qcDescription: "驳回理由",
    deliverDate: '发布时间',
    deliverStatus: '发布状态',
    deliverStatus_0: '待发布',
    deliverStatus_1: '已发布',
    deliverStatus_2: '无需发布',
    createUser: '操作人',
    reviewDate: "review 时间",
    recallTranslate: '此操作将恢复该段落, 是否继续?',
    noVersion: '无需生成版本',
    pending: "任务等待",
    choosePendingReason: "选择pending原因",
    pendingType_0: "无",
    pendingType_1: "等待气垫切割",
    pendingType_2: "等待防水报告",
    pendingType_3: "等待拍样更新",
    pendingType_4: "等待再生材料报告",
    pendingType_5: "等待防晒报告",
    versionDiff: "版本差异",
    hisVersion: "上一版本",
    currentVersion: "当前版本",
    versionInfo: "版本信息"
  },
  contrastTranslationHk: {
    global_en: "Global EN",
    translate: "Translate HKTC",
    sepc_review_en: "Spec Review EN",
    sepc_review_hktc: "Spec Review HKTC",
    line1: "LINE1",
    line2: "LINE2",
    long: "LONG",
    desc: "DESC",
    description: "LONG DESC",
    display_name: "Display Name",
  },
  copyDistribute: {
    id: "订单编号",
    productCode: "SKU",
    style: "STYLE",
    productName: "产品名称",
    category: "产品分类",
    enCopyStatus: "英文状态",
    zhCopyStatus: "中文状态",
    imageStatus: "图片状态",
    existGlobalImage_0: "无",
    existGlobalImage_1: "有",
    productInfoOwner: "下单人",
    compareUser: "校对人",
    status: "订单状态",
    omd: "OMD",
    age: "AGE",
    cnLaunchDate: "发布时间",
    hkLaunchDate: "HK发布时间",
    prodType: "产品类型",
    chooseImage: "选择图片",
    loading: "加载中...",
    upload: "上传",
    uploading: "上传中...",
    isFirst: "是否首次",
    inventoryStatus: "库存状态",
    existInventory_0: "无",
    existInventory_1: "有",
    sampleStatus: "调样状态",
    sampleStatus_0: "未调样",
    sampleStatus_1: "已调样",
    sampleStatus_2: "已上传",
    sampleStatus_3: "已发货",
    sampleStatus_4: "调样失败",
    platformType: "平台类型",
    platformType_0: "CN",
    platformType_1: "HK",
    platformType_2: 'TMALL',
    platformType_3: 'CN & TMALL',
    needAirbag: "需要切样",
    needAirbag_0: "否",
    needAirbag_1: "是",
    airbagStatus: "切样状态",
    airbagStatus_0: "未切样",
    airbagStatus_1: "已切样",
    writingStatus: "文案撰写",
    writingStatus_0: "否",
    writingStatus_1: "是",
    existTranslate: "翻译状态",
    existTranslate_0: "无",
    existTranslate_1: "有",
    isCampaign: "活动状态",
    isCampaign_0: "否",
    isCampaign_1: "是",
    genderGroup: "性别组",
    snkrsLaunch: "SNKRS",
    snkrsLaunch_Y: "是",
    snkrsLaunch_N: "否",
    taskStatus: "任务状态",
    taskStatus_0: "未分发",
    taskStatus_1: "未接收",
    taskStatus_2: "校对中",
    taskStatus_3: "QC中",
    taskStatus_4: "已完成",
    taskStatus2: "任务状态",
    taskStatus2_0: "未分发",
    taskStatus2_1: "可分发",
    taskStatus2_2: "未接收",
    taskStatus2_3: "已接收",
    startDate: "开始日期",
    endDate: "结束日期",
    priorityLevel: "优先级",
    priorityLevel_0: "初始中",
    priorityLevel_1: "低",
    priorityLevel_2: "中",
    priorityLevel_3: "高",
    priorityLevel_4: "紧急",
    search: "查询",
    reset: "重置",
    refresh: "刷新",
    distribute: "分发",
    distribute2: "校对分发",
    writingStatus2: "撰写分发",
    recall: "撤回",
    forward: "转发",
    forward2: "校对转发",
    forward3: "撰写转发",
    operation: "操作",
    daifenfa: "待分发",
    daijieshou: "待接收",
    high: "高",
    medium: "中",
    low: "低",
    all: "全部",
    translateUser: "校对人",
    taskTimes: "校对次数",
    chooseUser: "选择用户",
    startDate2: "翻译时间",
    lingotekOrOffline: "翻译来源",
    lingotekOrOffline_0: "Lingotek",
    lingotekOrOffline_1: "Offline",
    lingotekOrOffline_2: "无",
    lingotekOrOffline_3: "Phrase",
    taskType2: "翻译来源",
    taskType2_0: "Translation",
    taskType2_1: "Copywriting",
    lastUpdated: "翻译日期",
    campaign: "活动",
    reject: "驳回",
    specialCase: "KEY",
    reOpen: "重做",
    taskType: "任务类型",
    taskType_0: "NEW",
    taskType_1: "UPDATE",
    taskType_2: "过期失效",
    sizingFit: "翻译类型",
    sizingFit_0: "PDP",
    sizingFit_1: "S&F",
    downCopy: "下载文案",
    finishedStyleCount: "当天已完成style数",
    styleCount: "未完成style数",
    skuCount: "未完成sku数"
  },
  dictCopyErrorType: {
    gmtModified: "修改时间",
    errorType: "错误类型",
    isDelete: "",
    remark: "备注",
    id: "",
    gmtCreate: "创建时间",
    attribution: '属性',
    defectCategory: '缺陷类别',
    headline: '标题',
    instruction: '说明',
    nonEnError: '无英文错误',
    enError: '英文错误',
    deduction: '扣分',
    platformType: '平台类型',
    platformType_0: 'CN',
    platformType_1: 'HK'
  },
  dictImageErrorType: {
    gmtModified: "修改时间",
    errorType: "错误类型",
    isDelete: "",
    remark: "说明",
    id: "",
    gmtCreate: "创建时间"
  },
  copyUpload: {
    uploadDate: "上传日期",
    translateCreateDate: "英文创建日期",
    translateOverDate: "翻译完成日期",
    code: "STYLE/SKU",
    isStyle: "类型",
    isStyle_0: "STYLE",
    isStyle_1: "SKU",
    line1: "LINE1",
    line2: "LINE2",
    line2Zh: "LINE2翻译",
    startDate: "开始日期",
    endDate: "结束日期",
    search: "查询",
    reset: "重置",
    chooseFile: "选择文件",
    loading: "加载中...",
    upload: "上传",
    uploading: "上传中...",
    excelName: "文件名称",
    createUser: "上传人",
    createTime: "上传时间",
    translateUser: "翻译人",
    distribute: "分发",
    distributing: "分发中...",
    distributeStatus: "分发状态",
    all: "全部",
    distributeStatus_0: "未分发",
    distributeStatus_1: "已分发",
    distributeTime: "分发时间",
    operation: "操作",
    pleaseChooseFile: "请选择文件！",
    uploadSuccess: "上传成功！",
    download: "下载",
    uploadEN: "上传EN",
    uploadHKTC: "上传HKTC",
    chooseUser: '选择用户',
    status: "处理状态",
    status_0: "未处理",
    status_1: "已处理",
    enStatus_0: "未处理",
    enStatus_1: "处理中",
    enStatus_2: "处理成功",
    enStatus_3: "处理失败",
  },
  copyTranslate: {
    startTreate: "开始处理",
    translate: "文案校对",
    startTranslate: "开始处理",
    writing: "文案撰写",
    translateUpdate: "文案更新"
  },
  copyQc: {
    qc: "QC",
    backList: "返回列表"
  },
  sampleDistribute: {
    id: "订单编号",
    listType: "订单类型",
    productCode: "SKU",
    productName: "产品名称",
    category: "产品分类",
    genderGroup: "性别组",
    isHkOnly: "是否HK Only",
    hkOnly_0: "否",
    hkOnly_1: "是",
    inventoryStatus: "库存状态",
    existInventory_0: "无",
    existInventory_1: "有",
    sampleStatus: "调样状态",
    sampleStatus_0: "未调样",
    sampleStatus_1: "已调样",
    sampleStatus_2: "已上传",
    sampleStatus_3: "已发货",
    sampleStatus_4: "调样失败",
    prodType: "产品类型",
    productInfoOwner: "下单人",
    status: "订单状态",
    cnLaunchDate: "OMD",
    startDate: "开始日期",
    endDate: "结束日期",
    search: "查询",
    reset: "重置",
    refresh: "刷新",
    distribute: "分发",
    recall: "撤回",
    operation: "操作",
    chooseImage: "选择图片",
    loading: "加载中...",
    upload: "上传",
    uploading: "上传中...",
    all: "全部",
    high: "高",
    medium: "中",
    low: "低",
    compareUser: "校对人",
    chooseUser: "选择用户",
    sampleDistributeUser: "调样人",
    sampleDistributeTeam: "调样团队",
    sampleDistributeTime: "调样时间",
    sampleUploadTime: "拍样时间",
    sample: "发送调样",
    sampleLoading: "调样中...",
    fileName: "文件名称",
    shippingList: "发货清单",
    uploadResult: "处理结果",
    uploadResult_0: '待处理',
    uploadResult_1: '处理中',
    uploadResult_2: '处理成功',
    uploadResult_3: '处理异常',
    createUser: '操作人',
    createTime: '操作时间',
    sampleDispatchTime: '发货日期',
    selectSampleDispatchTime: '请选择发货日期'
  },
  copyReturn: {
    code: 'STYLE/SKU',
    downloadTime: '下载时间',
    startDate: "开始时间",
    endDate: "结束时间",
    uploadStatus: '回传状态',
    all: '全部',
    uploadStatus_0: '可回传',
    uploadStatus_1: '已回传',
    taskStatus: "任务状态",
    taskStatus_0: "未分发",
    taskStatus_1: "未接收",
    taskStatus_2: "校对中",
    taskStatus_3: "QC中",
    taskStatus_4: "已完成",
    qcTime: "QC提交时间",
    isStyle: "任务类型",
    isStyle_0: "STYLE",
    isStyle_1: "SKU",
    operation: "操作",
    return: '回传',
    reOpen: '重新回传',
    productCode: "SKU",
    productName: "产品名称",
    category: "产品分类",
    prodType: "产品类型",
    genderGroup: "性别组",
    omd: "OMD",
    outputByStyle: "输出类型",
    outputByStyle_0: "STYLE",
    outputByStyle_1: "SKU",
    linguisticCopy: "Linguistic Review",
    specCopy: "Spec Review",
    finalCopy: "Final Review",
    setReturnTime: "待回传时间"
  },
  productManage: {
    id: "订单编号",
    listType: "订单类型",
    productCode: "SKU",
    productName: "产品名称",
    category: "产品分类",
    genderGroup: "性别组",
    inventoryStatus: "库存状态",
    existInventory_0: "无",
    existInventory_1: "有",
    sampleStatus: "调样状态",
    existGlobalImage: 'Global图片状态',
    existGlobalImage_0: '无',
    existGlobalImage_null: '无',
    existGlobalImage_1: '有',
    isHideImage: '隐藏状态',
    isHideImage_0: '无',
    isHideImage_null: '无',
    isHideImage_1: '有',
    isDeliverImage: '任务状态',
    isDeliverImage_0: '未完成',
    isDeliverImage_null: '未完成',
    isDeliverImage_1: '已完成',
    sampleStatus_0: "未调样",
    sampleStatus_1: "已调样",
    sampleStatus_2: "已上传",
    sampleStatus_3: "已发货",
    sampleStatus_4: "调样失败",
    prodType: "产品类型",
    status: "订单状态",
    cnLaunchDate: "OMD",
    startDate: "开始日期",
    endDate: "结束日期",
    search: "查询",
    reset: "重置",
    operation: "操作",
    all: "全部",
    sampleImage: "拍样",
    globalImage: "Global原图",
    CNCopyInfo: "CN COPY",
    HKCopyInfo: "HK COPY",
    copyInfo: "COPY信息",
    source: "原文",
    finalReview: "翻译",
    line2Zh: "line2翻译",
    hkDescription: "HK翻译",
    isStError: 'ST状态',
    stView: 'ST校对结果',
    premView: 'PREM校对结果',
    hiddenStatus: '隐藏状态',
    isPremError: 'PREM状态',
    isHide: '隐藏状态',
    confidentialFlag: '保密状态',
    confidentialDate: '保密到期日期',
    userName: '审核人',
    orgName: '审核团队',
    isStError_null: '--',
    isStError_0: '正确',
    isStError_1: '错误',
    isPremError_null: '--',
    isPremError_0: '正确',
    isPremError_1: '错误',
    qcTime: 'QC时间',
    memberShip: 'MEMBERSHIP OFFER DATE',
    snkrsLaunch_null: '',
    snkrsLaunch_Y: "是",
    snkrsLaunch_N: "否",
    simpleDate: "调样/发货日期",
    bzSimpleDate: "BZ调样日期",
    imageUploadDate: "BZ图片上传日期",
    globalImageStatus: "Global图片状态",
    release: '发布记录',
    rawImage: '原图',
    omd: "OMD",
    ST: "ST",
    PREM: "PREM",
    folderBatchNo: '批次',
    bzImageStatus: "BZ图片状态",
    bzImageStatus_0: '无',
    bzImageStatus_null: '无',
    bzImageStatus_1: '有',
    exportRelease: '导出发布记录',
    releaseTime: "发布时间",
    imageErrorDescription: '错误内容'
  },
  copyCombine: {
    startDate: "开始日期",
    endDate: "结束日期",
    productCode: "SKU",
    productName: "产品名称",
    category: "产品分类",
    genderGroup: "性别组",
    prodType: "产品类型",
    omd: "OMD",
    operation: "操作",
    newCopy: '最新版本',
    submitAll: "全部提交",
    combineSuccess: "合并成功！",
    combine: '合并',
    combineStatus: '合并状态',
    combineTime: '合并提交时间',
    style: 'STYLE',
    outputLevel: "输出级别",
    outputByStyle_0: "STYLE",
    outputByStyle_1: "SKU",
    combineStatus_0: "待合并",
    combineStatus_1: "合并中",
    combineStatus_2: "已合并",
    combineStatus_3: "无需合并",
    needCombine: "需要合并",
    submitStatus: "合并状态",
    all: "全部",
    submitStatus_0: "可合并",
    submitStatus_1: "已合并",
    submitStatus_2: "无需合并",
    linguisticCopy: "Linguistic Review",
    specCopy: "Spec Review",
    finalCopy: "Final Review",
    versionInfo: "版本信息",
    notCombineCanNotSubmit: "当前STYLE还未合并，请合并后再提交！",
    thisVersion: "该版本是由：",
    combineGet: "合并生成！",
    source: "英文",
    translation: "翻译",
    taskFinalCopy: "Final Review",
    currentVersion: "当前版本",
    editVersion: "合并中版本",
    backList: "返回列表",
    copy: "复制",
    edit: "编辑",
    save: "保存",
    startCombine: "开始合并",
    unCombine: "无需合并",
    gmtCreate: "创建时间",
    sourceTaskStartDate: "翻译时间",
    translateUserList: "校对人列表",
    combineUser: "合并人"
  },
  readiness: {
    searchComment: '开始时间和结束时间不能为空',
    platform: 'PLATFORM',
    contents: 'CONTENTS',
    seasonalTotal: 'SEASONAL TOTAL',
    total: 'Total',
    imageReady: 'Image READY',
    correct: 'CORRECT',
    error: 'ERROR',
    stError: 'ST Error',
    premError: 'PREM Error',
    inProduction: 'IN PRODUCTION',
    noGlobalImages: 'No Global Images',
    noSample: 'No Sample',
    verifying: 'Verifying',
    noSampleImage: 'OUT OF WORK',
  },
  copyReadiness: {
    searchComment: '开始时间和结束时间不能为空',
    platform: 'PLATFORM',
    contents: 'CONTENTS',
    seasonalTotal: 'SEASONAL TOTAL',
    total: 'Total',
    copyReady: 'Copy READY',
    inProduction: 'IN PRODUCTION',
    lwReviewed: 'LW Reviewed',
    copyWrited: 'Copy Writed',
    lwReviewing: 'LW Reviewing',
    lwCopyWriting: 'LW Copy Writing',
    outOfWork: 'OUT OF WORK',
    noSample: 'Translation Delivered, no Inventory',
    noTranslation: 'Inventory delivered, no Translation',
    noSampleTranslation: 'No Translation, no Inventory',

  },
  copyProduct: {
    code: 'STYLE/SKU',
    platformType: '平台类型',
    deliverDate: '发布时间',
    deliverStatus: '发布状态',
    deliverStatus_0: '未发布',
    deliverStatus_1: '已发布',
  },
  sysMail: {
    Receiver: '接收人',
    gmtModified: '修改时间',
    type: '邮件类型',
    toMails: '邮件接收人',
    ccMails: '邮件抄送人',
    bccMails: '邮件密送人',
    gmtCreate: '创建时间',
    deleteInfo: '此操作将永久删除角色, 是否继续?'
  },
  sysReport: {
    chooseReport: "报表名称",
    chooseDate: "报表日期",
    reportName: "报表名称",
    reportNum: "报表名称",
    startTime: "报表时间",
    endTime: "结束时间",
    gmtCreate: "发送时间",
    sendType: "发送类型",
    sendType_0: "系统发送",
    sendType_1: "手动发送",
    sendStatus: "发送状态",
    download: "下载",
    sendUser: "发送人",
    status: "发送状态",
    status_0: "发送成功",
    status_1: "发送失败",
    status_2: "无数据",
    status_3: "未上传",
    startSend: "开始发送",
    reportTime: "报表日期",
    sendAll: "发送当天全部",
    sender: "选择收件人"
  },
  manualTrackingList: {
    export: "更新导出",
    expiredTime: "失效天数",
    gmtCreate: "上传时间"
  },
  sftpUpload: {
    season: "SEASON",
    SKU: "SKU",
    ST: "ST",
    PREM: "PREM",
    st_0: "",
    st_1: "已上传",
    st_2: "无图",
    st_3: "无需上传",
    st_4: "比对中",
    prem_0: "",
    prem_1: "已上传",
    prem_2: "无图",
    prem_3: "无需上传",
    prem_4: "比对中",
    uploadTime: "发布时间",
    download: "下载",
    status: "发布状态",
    status_0: "待上传",
    status_1: "已上传",
    infographic: "INFOGRAPHIC"
  },
  sizeChart: {
    season: '季度',
    isMissing: '尺码表缺失',
    version: "版本",
    upload: "上传",
    download: "下载",
    edit: "编辑",
    save: "保存",
    dispose: "配置",
    acceptAll: "一键接受",
    saveSuccess: "保存成功",
    cannotChange: "已发布，无法变更",
    uploadSuccess: "上传成功",
    uploadFailure: "上传失败",
    refuseEnter: '你不能以这种方式进入审查页面',
    platform: '平台',
    SizeChart: 'Size Chart',
    SKUSizeChart: 'SKU & Size Chart',
    StyleSKU: "Style/SKU",
    review: '审查',
    sync: '同步',
    releaseNow: '立即发送',
    SpecifyDate: '指定日期发送',
    releaseToday: '当天发送',
    release: '发布',
    tobeReview: '个待审查的变更',
    headKey: "key",
    headName: "表头",
    isBizPk: "基准尺码",
    isHide: "是否显示",
    sizeChartName: '名称',
    sizeChartCodeName: '代码',
    enableFlag_null: '禁用',
    enableFlag_0: '启用',
    enableFlag_1: '禁用',
    sizeChartCode: '尺码表代码',
    sizeChartNameEn: '尺码表名称（英文）',
    sizeChartNameCn: '尺码表名称（中文）',
    sizeChartNameTc: '尺码表名称（繁体）',
    productType: '类型',
    sizeChartUrl: '官网地址',
    enableLable: '爬取标签',
    enableLableTc: '爬取标签（繁体）',
    titlePosition: '标签序号',
    sizeChartPosition:'展示顺序',
    parentSizeChartCode: '父级尺码表',
    enableFlag: '爬取开关',
  },
  localImage: {
    reviewer: "审核人",
    taskType: "任务类型",
    assetsType: "资产类型",
    season: "季度",
    productCode: "Style/SKU",
    style: "Style",
    code: "Style/SKU",
    platform: "拍摄平台",
    image: "图片",
    video: "视频",
    shootingMethod: "拍摄方法",
    imageName: "图片名称",
    dimension: "尺寸",
    review: "审核",
    createBy: "创建人",
    createTime: "创建时间",
    startDate: "开始时间",
    endDate: "结束时间",
    createTask: "创建任务",
    source: "来源",
    createTask_0: "BOX",
    createTask_1: "Upload",
    createTask_2: "Sftp",
    modelStatusAll: "全部",
    modelStatus_0: "过期",
    modelStatus_1: "有效",
    fileName: "文件名",
    uploader: "上传人",
    uploadTime: "上传时间",
    chooseFile: "选择文件",
    uploading: "上传中",
    upload: "上传",
    pleaseChooseFile: "请选择文件！",
    pleaseUploadFile: "请上传文件！",
    pleaseInputFilePath: "请输入文件路径！",
    uploadSuccess: "上传成功",
    biComparison: "BI比对/审核",
    biComparison_1: "BI比对",
    biComparison_0: "审核",
    processingProgress: '处理进度',
    processingProgress_0: '待处理',
    processingProgress_1: '处理中',
    processingProgress_2: '已完成',
    processingProgress_3: '处理失败',
    processingProgress_4: '有异常',
    sku_level_upload_progress: 'SKU LEVEL上传进度',
    cn_release_progress: 'CN发布进度',
    tmall_release_progress: 'TMALL发布进度',
    processingDetail: '处理详情',
    uploadFile: '文件上传',
    processingDetailView: '查看',
    folderBatchNo: '批次',
    boxLink: "BOX Link",
    uploadDes: "上传",
    filePath: "文件路径",
    seasonErr: "季度不能为空",
    boxLinkErr: "boxLink不能为空",
    modelEffectiveDaysErr: "模特有效期不能为空",
    submitCreateTaskSuccess: "任务创建成功",
    successProcessingNum: "成功处理数量",
    failProcessingList: "异常处理清单",
    path: "路径",
    state: "状态",
    aiState: "AI预审",
    reason: "原因",
    exception_0: "成功",
    exception_1: "跳过",
    exception_2: "异常",
    all: "全部",
    review_status_0: "待审核",
    review_status_1: "已通过",
    review_status_2: "已拒绝",
    review_status_3: "已更新",
    review_status_4: "已发布",
    aiReview_status_0: "无需审核",
    aiReview_status_1: "待审核",
    aiReview_status_2: "审核通过",
    aiReview_status_3: "审核拒绝",
    importTime: "导入时间",
    operate: "操作",
    pass: "通过",
    refuse: "拒绝",
    examine: "审核",
    reExamine: "重新审核",
    reviewInfo11: "确认重新审核？",
    wrongAnnotation: "错误标注",
    opinion: "审核意见",
    reviewTime: "审核时间",
    opinionCanNotNull: "审核意见不能为空",
    reviewInfo1: "确认通过？",
    reviewInfo2: "确认拒绝？",
    reviewInfo3: "确认发布？",
    downloadList: "下载清单",
    reviewRefuse: "审核拒绝",
    batchReview: "批量审核",
    batchPass: "批量通过",
    batchRefuse: '批量拒绝',
    noReviewData: "没有审核数据",
    downStart: "开始下载",
    downEnd: "下载结束",
    modelEffectiveDays: "模特有效期",
    isExpired: "是否有效",
    forever: "永久",
    releaseDetail: "发布详情",
    tm: "TM发布",
    tmDate: "发布时间",
    cn: "CN.COM发布",
    cnDate: "发布时间",
    c4c: "CN.COM发布",
    c4cDate: "发布时间",
    releaseStatus_null: "未发布",
    releaseStatus_0: "未发布",
    releaseStatus_1: "已发布",
    releaseStatus_2: "待发布",
    releasePlatform: "发布平台",
    releaseTime: "发布时间",
    manualRelease: "人工发布",
    notRelease: "还未发布",
    biComparison_1_: "BI比对",
    biComparison_0_: "审核",
    noThing: "无",
    batchReviewSn: "待审核",
    reviewDetail: "审核详情",
    cn2: "APP&MNP",
    tm2: "TMALL",
    c4c2: "CN.COM",
    DataType: "数据类型",
    imageType:"图片类型",
    tag: "标签",
    tagExist: "标签已存在！",
  },
  attributeManagement: {
    platform_0: 'CN',
    platform_2: 'TM',
    attributeEdit: "属性维护",
    attribute: "属性",
    attrNameEn: "属性(英文)",
    attrNameCn: "属性(中文)",
    valueSet: "值集",
    logic: "逻辑",
    valueSetEdit: "值集维护",
    attrValueEn: "属性值(英文)",
    attrValueCn: "属性值(中文)",
    logicEdit: "逻辑配置",
    createBy: "创建人",
    createTime: "创建时间",
    updateBy: "修改人",
    updateTime: "修改时间",
    entityName: "来源",
    validState: "是否生效",
    validState_0: "未生效",
    validState_1: "已生效",
    effective: "生效",
    effectiveResults: "生效结果",
    resultStatus: "结果",
    resultMessage: "内容",
    config: "配置",
    steps: "步骤",
    stepType_1: "Filter",
    stepType_2: "Switch",
    stepType_3: "Mapping",
    inputFrom: "输入来源",
    inputFrom_1: "前置步骤",
    inputFrom_2: "来源中的字段",
    inputFrom_3: "无来源",
    inputLang: "输入语言",
    inputLang_1: "英文",
    inputLang_2: "中文",
    defaultValue: "默认值",
    field: "字段",
    operator: "运算符",
    value: "值",
    logicalSymbol: "逻辑符",
    addSubexpression: "添加子表达式",
    branch: "分支",
    outputValue: "输出值",
    returnIfMatch: "匹配后返回",
    returnIfMatch_0: "否",
    returnIfMatch_1: "是",
  },
  assetsUploadList: {
    startDate: "开始日期",
    endDate: "结束日期",
    fileType: "文件类型",
    all: "全部",
    fileType_0_1: "Global Image",
    fileType_0_2: "Sample Image",
    search: "查询",
    reset: "重置",
    chooseFile: "选择文件",
    loading: "加载中...",
    upload: "上传",
    uploadTrackingList: "上传TrackingList",
    uploadCampaignList: "上传CampaignList",
    uploading: "上传中...",
    fileName: "文件名称",
    createBy: "上传人",
    orgCode: "上传团队",
    createTime: "上传时间",
    pleaseChooseFile: "请选择文件！",
    pleaseUploadFile:"请上传文件！",
    uploadSuccess: "上传成功！",
    imageTaskInProcess: '图片任务后台生成中，请稍后再试',
    uploadFailed: "上传失败！",
    updateTask: "确认当天TL已全部上传",
    uploadAll: "您今天已经全部上传完TrackingList和CampaignList，确定开始更新任务吗？",
    submitSuccess: "您已提交成功，任务开始更新！",
    excelIsParsing: "文件解析未处理完成，请稍后重新提交！",
    taskIsRunning: "目前任务正在更新，请稍后重新提交！",
    uploadSkuList: "上传skuList",
    status: "当前状态",
    status_0: "待处理",
    status_1: "处理完成",
    status_2: "处理异常",
    status_3: "处理中",
    fileUpload: "文件上传",
  },
  professionalWord:{
    currentPlatformPype: '当前平台此类型',
    and: '和',
    deleteInfo: '是否删除当前专业词?',
    professionalWord: '专业词',
    professionalWordEN: '专业词（EN）',
    descriptionEN: '说明（EN）',
    professionalWordZH: '专业词（SC）',
    descriptionZH: '说明（SC）',
    professionalWordTC: '专业词（TC）',
    descriptionTC: '说明（TC）',
  },
  forbiddenWord:{
    currentPlatform: '当前平台',
    deleteInfo: '是否删除当前禁用词?',
    forbiddenWord: '禁用词',
    description: '说明',
  },
  disclaimer:{
    deleteInfo: '是否删除当前免责声明?',
    disclaimer: '免责声明',
    keyWord: '关键词',
    content: '免责内容EN',
    contentTranslate: '免责内容SC（CN.COM）',
    contentHk: '免责内容TC',
    applyEc: '适用EC',
    contentTm: '免责内容SC（EC）',
    applicableProduct: '适用产品',
    description: '标题'
  },
  sysDict: {
    dict: "字典",
    dictData: "数据",
    code: "编号",
    name: "名称",
    remark: "备注",
    detail: "说明",
    updateBy: "更新人",
    updateTime: "更新时间",
    operation: "操作",
  },
  copyBiRule: {
    copyBiRule: '文案校对规则',
    name : "规则名称",
    keyWord: "关键词",
    matchRule: "匹配规则",
    description: "提示信息",
    deleteInfo: '此操作将删除文案校对规则, 是否继续?',
    imageInfo: '图片',
    matchRule_0: '货号',
    matchRule_1: '产品类型',
    matchRule_2: 'EN文案',
    matchRule_3: 'ZH文案',
  },
  imageBiRule: {
    imageBiRule: '图片校对规则',
    type: '案例类型',
    title : '标题',
    keyWord: '关键词',
    productList: '货号/品名',
    imageInfo: '图片',
    tag: '标签',
    ruleContent: '规则内容',
    basicReason: '根本原因',
    legalAdvice: '法务意见',
    deleteInfo: '此操作将删除图片校对规则, 是否继续?',
  },
  imageCertificateList: {
    sku: "SKU/STYLE",
    productCode: "SKU",
    productName: "产品名称",
    sampleStatus: "调样状态",
    sampleStatus_0: "未调样",
    sampleStatus_1: "已调样",
    sampleStatus_2: "已上传",
    sampleStatus_3: "已发货",
    sampleStatus_4: "调样失败",
    existCertificate: "有无合格证",
    existCertificate_0: "无",
    existCertificate_1: "有",
    existShoeBox: "有无鞋盒贴标",
    existShoeBox_0: "无",
    existShoeBox_1: "有",
    sampleBatch: "拍样批次",
    status: "当前状态",
    status_0: "待确认",
    status_1: "已确认",
    status_2: "暂缺",
    updateTime: "更新时间",
    operation: "操作",
    certificate: "合格证",
    selectCertificate: '选择合格证',
    selectShoeBox: '选择鞋盒标贴',
    change: '切换',
    rawImage: '原图',
  },
  license: {
    uploadSuccess: "上传成功！"
  },
  sellPoint: {
    fileType_12_1: "video",
    fileType_12_2: "infographic",
    fileType_12_3: "TOP200",
    fileType_12_4: "AR锚点",
    fileType_12_5: "动态主图",
    fileType_12_6: "Fast",
    fileType_13_1: "video",
    fileType_13_2: "infographic",
    fileType_13_3: "TOP200",
    fileType_13_4: "AR锚点",
    fileType_13_5: "动态主图",
    fileType_13_6: "Fast",
    status: '处理进度',
    status_0: '待处理',
    status_1: '处理完成',
    status_2: '处理异常',
    status_3: '处理中',
    operate: '操作',
    uploading: "上传中...",
  },
  launchTracking: {
    upload: '上传',
    fileName: '文件名称',
    uploader: '上传人',
    uploadTime: '上传时间',
    currentStatus: '当前状态',
    status: "处理进度",
    status_0: "待处理",
    status_1: '处理完成',
    status_2: '处理异常',
    status_3: '处理中',
    headerParsingResult: '表头解析结果',
    isParsed: '是否解析',
    parsed: '解析',
    skipped: '跳过',
    unparsedData: '未解析数据',
    showLogId: '显示日志 ID:',
    openUploadDialog: '打开上传弹窗',
    pleaseChooseFile: '请选择文件',
    taskProcessing: '任务处理',
    fileListUpload: '清单上传',
    resultUpload: '结果上传',
    dataQuery: '数据查询',
    type: '类型',
    season: 'SEASON',
    gender: 'GENDER',
    age: 'AGE',
    enrichedCopy: 'ENRICHED COPY',
    nikeComEcoLaunchDate: 'NIKE.COM ECO LAUNCH DATE',
    productNameInProdigy: 'PRODUCT NAME IN PRODIGY',
    platform: 'PLATFORM',
    launchType: 'LAUNCH TYPE',
    fullColorDescription: 'FULL COLOR DESCRIPTION',
    taskStatus: 'TASK STATUS',
    enrichedCopyDelivered1: 'ENRICHED COPY DELIVERED 1',
    enrichedCopyDelivered2: 'ENRICHED COPY DELIVERED 2',
    updateTime: 'UPDATE TIME',
    comments: 'Comments',
    publishStatus: 'PUBLISH STATUS',
    publishTime: 'PUBLISH TIME',
    uploadPerson: '上传人',
    operation: '操作',
    pleaseSelectFileType: '请选择文件类型',
    addingSuccess: '添加成功！',
    addingFailed: '添加失败！',
    enrichedCopyDelivered1Required: '请输入 enrichedCopyDelivered1',
    enrichedCopyDelivered2Required: '请输入 enrichedCopyDelivered2',
    publishStatusList: '发布状态',
    publishStatusList_null: '',
    publishStatusList_0: '待发布',
    publishStatusList_1: '已发布',
    taskStatusList: '任务状态',
    taskStatusList_null: '',
    taskStatusList_0: '待分发',
    taskStatusList_1: '已分发',
    taskStatusList_2: '已过期',
    uploadStatus: 'UPLOAD STATUS',
    uploadStatus_null: '',
    uploadStatus_0: '待上传',
    uploadStatus_1: '已上传',
    uploadStatus_2: '上传异常',
    uploadStatus_3: '上传中',
    resultPublishTime: 'UPLOAD TIME',
    dueDate: 'Due Date',
    inventoryStatus: '库存状态',
    existInventory_0: "无",
    existInventory_1: "有",
    existTranslate: "翻译状态",
    existTranslate_0: "无",
    existTranslate_1: "有",
    copyStatus: '文案状态',
    copyStatus_0: '无',
    copyStatus_1: '有',
    copyStatus_2: '无（CopyWritting）',
    copyStatus_3: '无(有翻译有库存)',
    copyStatus_4: '无(有翻译无库存)',
    copyStatus_5: '无(无翻译有库存)',
    copyStatus_6: '无(无翻译无库存)',
    archiveConfirm: '是否确认归档所选内容',
    fileList: '清单列表',
    taskAssignment: '任务分发',
  },
  keyWords:{
    status: '处理进度',
    status_0: '待处理',
    status_1: '处理完成',
    status_2: '处理异常',
    status_3: '处理中',
    publishInfo: '请选择需要发布的数据',
    publishTime: '发布时间',
    uploadTime: '上传时间',
    publishReason: '发布原因',
    keywordsPublishInfo: '关键字发布详情',
    keywordsUploadInfo: '关键字上传详情',
    copyPublishDetail: '文案发布详情',
    publishOk: "发布成功",
    publishError: "发布失败,稍候重试",
    keywordsStatus_0: '未上传',
    keywordsStatus_1: '已上传',
    reportStatistics: '报表统计查询',
    season: '季度',
    noAccessed: "无文案",
    releaseStatus_null: '全部',
    releaseStatus_0: '未发布',
    releaseStatus_1: '已发布',
    platform: '平台',
    planning: '是否基于planning发布',
    detailReleaseStatus_null: '',
    detailReleaseStatus_0: '未发布',
    detailReleaseStatus_1: '已发布',
    detailReleaseStatus_2: '无需发布',
  },
  measurement:{
    status_0: '待处理',
    status_1: '处理完成',
    status_2: '处理异常',
    status_3: '处理中',
    operate: '操作',
    published: "已发布",
    unpublished: "未发布",
    uploading: "上传中...",
    pleaseChooseFile: "请选择文件！"
  },
  infographicTask: {
    fileUpload: '文件上传',
    dataManage: '数据管理',
    ChooseFile: '选择文件',
    productName: '产品名称',
    upload: '上传',
    search: '搜索',
    download: '数据下载',
    downloadImage: '图片下载',
    selSeason: '请选择季度',
    excelName: "文件名称",
    createUser: "上传人",
    createTime: "上传时间",
    status: '处理状态',
    status_0: '待处理',
    status_1: '处理完成',
    status_2: '处理异常',
    status_3: '处理中',
    addSeason: '添加季度',
    editSeason: '编辑季度',
    season: '季度',
    pleaseChooseFile: "请选择文件！",
    uploading: "上传中...",
    saveInfo: "是否保存？",
    saveInfoIsNull: "内容不能为空，请输入！",
    productCategory: "产品分类",
    fitExperience: "试穿体验",
    customerFeedback: "客户反馈",
    commentCount: "评论数量",
    diagnosisStatus: "诊断状态",
    negativeJudgement: "负面评价",
    tryToFeel: "试穿感受",
    newSeason: "最新季度",
    publishStatus: "发布状态",
    operate: "操作",
    pleaseChooseDetail: "请选择记录！",
    downloadFailed: "下载失败！",
    detail: "详情",
    published: "已发布",
    unpublished: "未发布",
    normal: "正常",
    abnormal: "异常",
    warning: "预警",
    noFeedback: "无反馈"
  },
  labelManagement: {
    season: "Season",
    style: "Style",
    keywords: "关键字",
    sellingPointsLabel: "卖点标签",
    configuration: "配置",
    label: "标签",
    date: "日期",
    blank: "置空",
    associated: "已关联",
    unassociated: "未关联",
    newTagging: '新标签',
    selectTagging: "选择标签",
    customTags: "自定义标签",
    newSeason: "新建季度",
    editSeason: "编辑季度",
    newTag: "新建标签",
    editTag: "编辑标签",
    seasons: "季度",
    createTime: "创建日期",
    deleteInfo: "是否确认删除这个季度",
    deleteInfoTag: "是否确认删除这个标签",
    enterSeasonName: "请输入季度名称",
    selectTag: "请选择标签",
    pleaseEnterTagName: "请输入标签名称",
    seasonExist: "季度已存在！",
    tagExist: "标签已存在！",
    tag: "新建标签",
    enterTag: "请输入标签",
    tagInfoIsNull: "标签不能为空！",
  },
  sizeAndFit: {
    downloadList: "下载清单",
    batchReCheck: "批量抽检",
    batchReview: "批量审核",
    status: "状态",
    status_null: "全部",
    status_0: '待审核',
    status_1: '待抽检',
    status_2: '已审核',
    detail: "详情",
    createBy: "上传人",
    createTime: "上传时间",
    excelName: "文件名称",
    upload: '上传',
    dataManage: "数据管理",
    fileUpload: '文件上传',
    season: "季度",
    submit: "提交",
    pass: "通过",
    refuse: "拒绝",
    batchPass: "全部通过",
    previous: "上一条",
    next: "下一条",
    close: "关闭",
    recall: "撤回",
    reviewSuccess: "审核成功",
    reviewFailed: "审核失败",
    reviewConfirm: "是否确认全部通过所有数据？",
    noReviewData: "当前记录暂无拍样数据，暂时无法审核！",
    noRecheckData: "当前记录暂无抽检数据，暂时无法抽检！",
    selectedUpload: "文件上传失败，请联系管理员！",
    startDate: "开始时间",
    endDate: "结束时间",
    submitInfo: '是否提交当前页面数据?',
    reviewType_null: "",
    reviewType_0: '审核',
    reviewType_1: '抽检',
  },
  errorTicket: {
    status: "Status",
    status_null: "全部",
    status_0: "待处理",
    status_1: "处理中",
    status_2: "关闭",
    urgent: "Urgent",
    Urgent: "加急",
    CancelUrgent: "取消加急",
    urgent_null: "全部",
    urgent_1: "是",
    urgent_0: "否",
    detail: "详情",
    edit: "编辑",
    more: "更多",
    download: "下载Report",
    downLoadList: "下载清单",
    close: "关闭",
    urgentConfirm: "是否确认对这条数据进行加急操作？",
    closeInfo: "是否确认关闭所有查询到的数据？",
    closeData: "是否确认关闭所选的",
    data: "数据？",
    selectedReport: "所选数据没有Error Ticket报告文件！",
    noReviewData: "没有审核数据",
    noRecheckData: "没有复检数据",
    cancelUrgentConfirm: "是否确认取消加急这条数据？",
  },
  storeManage: {
    storeMaintenance: "店铺维护",
    productName: "产品名称",
    productType: "产品类型",
    productCategory: "产品分类",
    genderGroup: "性别组",
    store: "店铺",
    upShelves: "上架",
    downShelves: "下架",
    shelves: "上/下架",
    maintainInfo: "是否确认维护这",
    data: "条数据？",
    selectSeason: "请选择季度",
    selectStore: "请选择需要维护的店铺",
    selectShelves: "请选择是否上架",
    selectedReport: "所选数据暂未生成Error Ticket报告文件，请稍后再试!"
  },
  HWTable: {
    fileName: '文件名称',
    platform: '平台',
    createUser: '上传人',
    createTime: '上传时间',
    status: '处理状态',
    status_0: '待处理',
    status_1: '处理完成',
    status_2: '处理异常',
    status_3: '处理中',
    ChooseFile: '选择文件',
    updateTime: '更新日期',
    uploadImage: '图片上传',
    releaseNow: '立即发布',
    release: '发布',
    isMissing: '尺码表缺失',
    download: '下载',
    batchEdit:"批量编辑",
    productName: '品名',
    productType: '产品类型',
    toMails: '邮件接收人',
    ccMails: '邮件抄送人',
    bccMails: '邮件密送人',
    selectToMails: "请选择邮件接收人",
    EditAllData: '是否确认编辑查询出的所有数据？',
    tableInfo: '请选择H/W Table',
    publishError: "发布失败,稍候重试",
    publishAllData: '是否确认发布查询出的所有数据？',
    selectPlatform: "请选择平台",
    uploading: "上传中......",
    selectedUpload: '上传成功',
    noFileInfo: '没有可以下载的文件',
    releaseStatus_null: "未发布",
    releaseStatus_0: "未发布",
    releaseStatus_1: "已发布",
    releaseStatus_2: "待发布",
    releaseStatus_3: "全部",
    releaseStatus_999: "-",
    deleteInfo: '是否确认删除这张图片？',
    saveSuccess: "保存成功",
    saveFailed: "保存失败",
    publishOk: "发布成功",
    noImageInfo: '没有可以删除的图片',
    noImage: '无图',
    Publish: '发布',
    publishInfo: '发布任务创建成功',
    publishFailedInfo: '发布任务创建失败',
    editInfo: '没有查到可以操作的数据'
  },
  colorDescription: {
    fileName: '文件名称',
    platform: '平台',
    createUser: '上传人',
    createTime: '上传时间',
    status: '处理状态',
    status_0: '待处理',
    status_1: '处理完成',
    status_2: '处理异常',
    status_3: '处理中',
    publishStatus: 'publish Status',
    publishStatus_0: 'pending',
    publishStatus_1: 'accomplish',
    ChooseFile: '选择文件',
    updateTime: '更新日期',
    uploadImage: '图片上传',
    releaseNow: '立即发布',
    release: '发布',
    isMissing: '尺码表缺失',
    download: '下载',
    batchEdit:"批量编辑",
    productName: '品名',
    productType: '产品类型',
    toMails: '邮件接收人',
    ccMails: '邮件抄送人',
    bccMails: '邮件密送人',
    selectToMails: "请选择邮件接收人",
    EditAllData: '是否确认编辑查询出的所有数据？',
    tableInfo: '请选择H/W Table',
    publishError: "发布失败,稍候重试",
    publishAllData: '是否确认发布查询出的所有数据？',
    selectPlatform: "请选择平台",
    uploading: "上传中......",
    selectedUpload: '上传成功',
    noFileInfo: '没有可以下载的文件',
    releaseStatus: "发布状态",
    releaseStatus_null: "",
    releaseStatus_0: "未发布",
    releaseStatus_1: "已发布",
    releaseStatus_999: "-",
    deleteInfo: '是否确认删除这张图片？',
    saveSuccess: "保存成功",
    saveFailed: "保存失败",
    publishOk: "发布成功",
    noImageInfo: '没有可以删除的图片',
    noImage: '无图',
    Publish: '发布',
    publishInfo: '发布任务创建成功',
    publishFailedInfo: '发布任务创建失败',
    editInfo: '没有查到可以操作的数据',
    searchColor: "搜索主色",
    releaseTime: "发布时间"
  },
  listUpload: {
    listUpload: '清单上传',
    taskGeneration: '任务生成',
    translationDownload: '翻译下载',
  },
  copyReview: {
    startReview: '开始审核',
    allSubmit: '全部提交',
    exceptionalStyle: 'Exceptional Style',
    pleaseSelectExceptionalStyle: '请选择 Exceptional Style',
    exceptionalStyleAllSelectedTip: '已上传拍样的 Style 不可全部设为 Exceptional！',
    nextStep: '下一步',
    prevStep: '上一步',
    applicableStyle: '适用Style',
    copyUpload: '文案回传',
    taskDetail: '任务详情',
    uploadStatus: '回传状态',
    uploadStatus_null: '',
    uploadStatus_0: '待回传',
    uploadStatus_1: '已回传',
    copyType: '文案类型',
    backList: "返回列表",
    takeSample: "拍样",
    translation: "翻译",
    source: "英文",
    reviewStatus: '审核状态',
    reviewStatus_0: "待审核",
    reviewStatus_1: "已审核",
    linguistiscReview: "Linguistic Review",
    specReview: "Spec Review",
    completionTimeOfTranslation: '翻译完成时间',
    versionInfo: "版本信息",
    detail: "详情",
    isSample_true: "有",
    isSample_false: "无",
    uploadSuccess: '回传成功',
    reviewer: '审核人',
    reviewTime: '审核时间',
    uploadTime: '回传时间',
    samplePhotoStatus: '拍样状态',
    samplePhotoStatus_all: '全部',
    samplePhotoStatus_0: '未上传',
    samplePhotoStatus_1: '已上传',
    samplePhotoStatus_2: '已上传/未上传',
    samplePhotoStatus_null: '',
    deleteSegmentTitle: '删除段落确认',
    deleteSegmentTip: '您即将永久删除以下文案段落，请选择其所属 module 后确认操作。',
    systemReference: '系统参考',
    viewWorkbook: '查看 workbook',
    pleaseSelectModule: '请选择 Module',
    selectModule: '选择module',
  },
  epdCopy: {
    copyVersion: '文案版本',
    originalTranslation: '原文/翻译',
    keyword: '关键字',
    phraseProjectName: 'Phrase Project Name',
    enTriggerTime: 'EN Trigger Time',
    reviewTime: '审核时间',
    reviewer: '审核人',
    deliverStatus: '交付状态',
    deliverStatus_0: '未交付',
    deliverStatus_1: '已交付',
    immediateDelivery: '立即交付',
    deliverSuccess: '交付成功',
    publishTime: '发布时间',
    deliverTime: '交付时间',
    translationCompletionTime: '翻译完成时间',
    downloadTime: '下载时间',
    reviewStatus: '审核状态',
    reviewStatus_0: "待审核",
    reviewStatus_1: "已审核",
    uploadStatus: '回传状态',
    uploadStatus_0: '待回传',
    uploadStatus_1: '已回传',
    uploadTime: '上传时间',
    dataUpload: '数据上传',
    translationDownload: '翻译下载',
    workbookUpload: 'Workbook上传',
  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang_zh.js